/* Custom JS (Kids Crew) */

/* Tabs collections "View all": on click hide the text and show a spinner until the collection page opens */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.hdt-tabs-collections .hdt-view-all-btn');
  if (!btn || btn.classList.contains('kc-loading')) return;
  if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
  btn.classList.add('kc-loading');
  var spinner = document.createElement('span');
  spinner.className = 'kc-spinner';
  spinner.setAttribute('aria-hidden', 'true');
  btn.appendChild(spinner);
});

/* Reset the button when coming back with the browser Back button (page restored from cache) */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('.hdt-view-all-btn.kc-loading').forEach(function (btn) {
    btn.classList.remove('kc-loading');
    btn.querySelectorAll('.kc-spinner').forEach(function (s) { s.remove(); });
  });
});
